// src/features/dashboard/superadmin/SuperAdminsTable.jsx
import React from 'react';

export const SuperAdminsTable = ({ superAdmins, onAdd, onDelete }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between">
        <h3 className="font-medium">Super Admin Users</h3>
        <button
          onClick={onAdd}
          className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
        >
          + Add Super Admin
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {superAdmins.length === 0 ? (
              <tr><td colSpan="3" className="px-4 py-3 text-center text-gray-500">No super admins found.</td></tr>
            ) : (
              superAdmins.map((sa) => (
                <tr key={sa.userId}>
                  <td className="px-4 py-2">{sa.name} {sa.surname}</td>
                  <td className="px-4 py-2">{sa.email}</td>
                  <td className="px-4 py-2">
                    <button onClick={() => onDelete(sa)} className="text-red-600 hover:underline text-sm">Delete</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};